import script from "./lease-parameters.vue?vue&type=script&setup=true&lang=js"
export * from "./lease-parameters.vue?vue&type=script&setup=true&lang=js"

import "./lease-parameters.vue?vue&type=style&index=0&id=2d126246&scope=true&lang=css"

const __exports__ = script;

export default __exports__